import { useEffect, useState } from "react";
import Navbar from "./components/common/commonComponents/Navbar";
import HomePage from "./pages/HomePage";
import Footer from "./components/common/commonComponents/Footer";

function App() {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  
  useEffect(() => {
    localStorage.setItem("theme", theme);
    if (theme === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [theme]);

  return (
    <>
      <div id="appCom" className={`min-h-screen w-full overflow-x-hidden relative transition-colors duration-300 ${theme === "dark" ? "dark bg-premium-dark text-premium-text" : "bg-lightWhite text-rich-black-900"}`}>
        
        {/* Subtle modern glowing background elements */}
        <div className={`fixed top-[-10rem] right-[-10rem] h-[30rem] w-[30rem] rounded-full blur-[10rem] transition-colors duration-700 pointer-events-none ${theme === "dark" ? "bg-accent-glow" : "bg-rich-purple-200 opacity-50"}`}></div>
        <div className={`fixed bottom-[-10rem] left-[-10rem] h-[30rem] w-[30rem] rounded-full blur-[10rem] transition-colors duration-700 pointer-events-none ${theme === "dark" ? "bg-purple-900/40" : "bg-blue-200 opacity-50"}`}></div>

        <Navbar theme={theme} setTheme={setTheme} style={{ zIndex: 9999 }}/>
        
        <main className="relative z-10 w-full flex flex-col items-center">
          <HomePage/>
        </main>
        
        <Footer/>
      </div>
    </>
  );
}

export default App;
